import { useState } from 'react'
import { EuConfirmDialog } from '@newamsterdam/ui'
import { useUser } from '../store/user'
import { useCompanyPicker } from '../store/companyPicker'
import { CompanyChooser } from '../auth/CompanyChooser'
import { companyErrorMessage } from '../auth/companyError'

export function CompanyPickerModal() {
  const open = useCompanyPicker((s) => s.open)
  const resolvePending = useCompanyPicker((s) => s.resolvePending)
  const close = useCompanyPicker((s) => s.close)

  const companies = useUser((s) => s.companies)
  const currentCompanyId = useUser((s) => s.current_company_id)
  const selectCompany = useUser((s) => s.selectCompany)

  const [choice, setChoice] = useState<string>(currentCompanyId ?? '')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [wasOpen, setWasOpen] = useState(open)

  if (open !== wasOpen) {
    setWasOpen(open)
    if (open) {
      setChoice(currentCompanyId ?? companies[0]?.id ?? '')
      setError(null)
      setSubmitting(false)
    }
  }

  async function handleConfirm() {
    if (submitting || !choice) return
    setError(null)
    setSubmitting(true)
    try {
      await selectCompany(choice)
      resolvePending()
    } catch (err) {
      setError(companyErrorMessage(err))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <EuConfirmDialog
      open={open}
      title="Wybierz spółkę"
      message="Wybierz spółkę, w kontekście której chcesz pracować."
      details={
        <CompanyChooser
          companies={companies}
          value={choice}
          onChange={setChoice}
          error={error}
          disabled={submitting}
        />
      }
      confirmLabel={submitting ? 'Przełączam...' : 'Wybierz'}
      cancelLabel="Anuluj"
      tone="default"
      onConfirm={() => void handleConfirm()}
      onCancel={close}
    />
  )
}
